import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({ 
  state: {
    snackbar: { showing: false, text: "", color:"", timeout: 2000},
  },
  mutations: {
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
  },
  actions: {
    setSnackbar({commit}, snackbar) {
      commit('SET_SNACKBAR', snackbar);
    },
  },
  modules: {
  }
})
